import React, { FunctionComponent, PropsWithChildren } from 'react';
import { Route, Router, Routes } from 'react-router-dom';
import './App.scss';
import IAuthService from './Services/AuthService';
import { useDispatch, useSelector } from 'react-redux';
import { loadUserSuccess, loadUserDetail, signOutUser } from './Store/Shared/actions';
import { User } from './Models/User';
import Home from './Components/Pages/Home/Home';
import DefaultAppContainer from './Components/Shared/DefaultAppContainer/DefaultAppContainer';
import PerformanceReporting from './Components/Pages/PerformanceReporting/PerformanceReporting';
import { loadLibrary } from './Store/Library/actions';
import { AppState } from './Store/rootReducer';
import LoadingIndicator from './Components/Shared/LoadingIndicator/LoadingIndicator';
// import ClientAdmin from './Components/Pages/ClientAdministration/ClientAdmin';
import UserManagement from './Components/Pages/UserManagement/UserManagement';
import PerformanceGroupManagement from './Components/Pages/PerformanceGroupManagement/PerformanceGroupManagement';
import DealerManagement from './Components/Pages/DealerManagement/DealerManagement';
import DealerGroupManagement from './Components/Pages/DealerGroupManagement/DealerGroupManagement';
import LoadingPanel from './Components/Controls/LoadingPanel/LoadingPanel';
import TicketSubmission from './Components/Pages/TicketSubmission/TicketSubmission';
import { useEffect } from 'react';
import $ from 'jquery';
(window as any).$ = (window as any).jQuery = $;
console.log($); 
type RouteProps = {
  authService: any,
  path: string;
  exact?: boolean;
  element: React.ComponentType<any>;
  // include other props as needed
};

function App(props: { authService: IAuthService }) {
  const auth = props.authService;
  const dispatch = useDispatch();
  const initializingApplication = useSelector((state: AppState) => state.shared.initializingApplication);
  props.authService.userSignedIn = (user: Partial<User>) => {
    dispatch(loadUserSuccess(user as User));
    dispatch(loadUserDetail());
    dispatch(loadLibrary());
  }

  props.authService.userSignedOut = () => {
    dispatch(signOutUser());
  }

  // Initialize authentication after callbacks are set
  useEffect(() => {
    auth.handlePageLoadEvent().catch(() => {
      // ignore; MSAL will redirect when needed
    });
  }, []);

  // function DefaultAppContainerRoute({ component: Component, authService: AuthService, ...rest }: any) {
  //   return (
  //     <Route
  //       {...rest}
  //       render={(props: any) => (
  //         <DefaultAppContainer {...props} {...rest} authService={AuthService}>
  //           <Component {...props} {...rest} authService={AuthService} />
  //         </DefaultAppContainer>
  //       )}
  //     />
  //   )
  // }

  const DefaultAppContainerRoute: FunctionComponent<PropsWithChildren<RouteProps>> = ({ path, element: Component, authService: AuthService, ...rest }) => {
    return (
      <Route path='/' element={<DefaultAppContainer authService={AuthService}><PerformanceReporting /></DefaultAppContainer>} />
    );
  };

  function NoMatch() {
    return (
      <div style={{ padding: 20 }}>
        <h2>404: Page Not Found</h2>
        <p>Lorem ipsum dolor sit amet, consectetur adip.</p>
      </div>
    );
  }

  return !initializingApplication ? (
    <Routes>
      <Route path='/' element={<DefaultAppContainer authService={auth}><PerformanceReporting /></DefaultAppContainer>} />
      <Route path='/home' element={<DefaultAppContainer authService={auth}><Home authService={auth}/></DefaultAppContainer>} />
      <Route path='/performanceReporting' element={<DefaultAppContainer authService={auth}><PerformanceReporting /></DefaultAppContainer>} />
      <Route path='/performanceReporting/:id' element={<DefaultAppContainer authService={auth}><PerformanceReporting /></DefaultAppContainer>} />
      <Route path='/dealerManagement' element={<DefaultAppContainer authService={auth}><DealerManagement /></DefaultAppContainer>} />
      <Route path='/ticket' element={<DefaultAppContainer authService={auth}><TicketSubmission /></DefaultAppContainer>} />
      <Route path='/userManagement' element={<DefaultAppContainer authService={auth}><UserManagement authService={auth} /></DefaultAppContainer>} />
      {/* <Route path='/performanceGroupManagement' element={<DefaultAppContainer authService={auth}><PerformanceGroupManagement /></DefaultAppContainer>} /> */}
      <Route path='/dealerGroupManagement' element={<DefaultAppContainer authService={auth}><DealerGroupManagement /></DefaultAppContainer>} />
      <Route path="*" element={<NoMatch />} />          
    </Routes>
  ) : (
    <LoadingPanel label={"Initializing Application..."} />
  )

}

export default App;

